import generateSpeech from "../utils/azureTextToSpeech";
import generateSignedURL from "../utils/generateSignedURL";
import { wordsByWord } from "../graphql/queries";
import { generateClient } from "aws-amplify/data";
import { updateGlobalItem } from "./updateTableItem";

export default async function handlePronunciation(searchTerm) {
  // Generate an Amplify data client
  const client = generateClient();

  try {
    // Query the database for the word using GraphQL
    const speechResponse = await client.graphql({
      query: wordsByWord,
      variables: { word: searchTerm, limit: 5 }, // Limit the results to 5 items
    });

    // Extract speech results from the query response
    const speechResults = speechResponse.data.wordsByWord?.items || null;

    // Check if the word exists in the database and if it already has a generated text-to-speech URL
    if (speechResults.length !== 0 && speechResults[0].textToSpeech) {
      console.log("Word and speech found in DB");
      const speechURL = speechResults[0].textToSpeech;
      console.log(speechURL);
      // Generate a signed URL for the S3 object
      const getUrlResult = await generateSignedURL(speechURL);
      // Play the audio from the signed URL
      console.log(getUrlResult.url);
      try {
        const audio = new Audio(getUrlResult.url);
        audio.play();
      } catch (playbackError) {
        console.error("Failed to play audio:", playbackError);
      }
    }
    // If the word exists but doesn't have a text-to-speech URL, generate the speech
    else if (speechResults.length !== 0) {
      try {
        console.log("Word found without speech in DB");
        // Generate speech using the Azure Text-to-Speech service
        const speechURL = await generateSpeech(searchTerm);
        // Generate a signed URL for the S3 object
        const getUrlResult = await generateSignedURL(speechURL);
        // Play the audio from the signed URL
        try {
          const audio = new Audio(getUrlResult.url);
          audio.play();
        } catch (playbackError) {
          console.error("Failed to play audio:", playbackError);
        }
        // Update the database with the URL
        await updateGlobalItem(speechResults[0].id, null, speechURL);
      } catch (error) {
        console.error("Failed to generate and save speech:", error);
      }
    }
    // If the word does not exist in the database, generate the speech without saving it
    else {
      try {
        console.log("Word not found in DB");
        // Generate speech using the Azure Text-to-Speech service
        const speechURL = await generateSpeech(searchTerm);
        // Generate a signed URL for the S3 object
        console.log(speechURL);
        const getUrlResult = await generateSignedURL(speechURL);
        // Play the audio from the signed URL
        console.log(getUrlResult.url);
        try {
          const audio = new Audio(getUrlResult.url);
          audio.play();
        } catch (playbackError) {
          console.error("Failed to play audio:", playbackError);
        }
      } catch (error) {
        console.error("Failed to generate speech:", error);
      }
    }
  } catch (error) {
    // Handle errors during the database query
    console.error("Failed to query DB:", error);
  }
}
